import styled from "@emotion/styled";

export const TitleCommon = styled.h1`
  display:block;
  font-family: ff-good-web-pro-condensed, sans-serif;
  text-align: center;
  text-transform: uppercase;
  color: ${(props) => props.color};
`;

export const TitleContainer = styled(TitleCommon)`
  span {
    font-size: 20vh;
    line-height: 0;
    @media screen and (max-height: 540px) and (min-width: 320px) {
      font-size: 106px;
    }
    @media screen and (max-width: 639px) and (orientation: portrait) {
      font-size: 27vw;
    }
  }
`
